<template>
  <div class="element-box">
    <h3>Agenda do Profissional {{ profissional.nome }}</h3>
    <div class="row">
      <div class="col">
        <form autocomplete="off" @submit.prevent="salvar()">
          
          <div class="form-row">
            <div class="col form-group col-md-6">
              <label for="tipoRegistro">Dia Semana</label>
              <select required v-model="agenda.dia_semana" name="diaSemana" id="diaSemana" class="form-control">
                <option :value="null">Selecione</option>
                <option v-for="diaSemana in listDiaSemana" :value="diaSemana" :key="diaSemana.key" v-text="diaSemana.name"></option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col form-group">
              <label for="horaInicio1">Horário Manhã</label>
              <input size="5" v-mask="'##:##'" v-model="agenda.hora_inicio_1" class="form-control" type="text" name="horarioInicio1" id="horarioInicio1">
              <input v-mask="'##:##'" v-model="agenda.hora_fim_1" class="form-control" type="text" name="horarioInicio2" id="horarioInicio2">
            </div>
            <div class="col form-group">
              <label for="horaInicio1">Horário Tarde</label>
              <input v-mask="'##:##'" v-model="agenda.hora_inicio_2" class="form-control" type="text" name="horarioFim1" id="horarioFim1">
              <input v-mask="'##:##'" v-model="agenda.hora_fim_2" class="form-control" type="text" name="horarioFim2" id="horarioFim2">
            </div>
          </div>
          <hr />
          <button class="btn btn-warning" type="submit">Salvar</button>
        </form>
      </div>
      <div class="col">
        <div class="element-wrapper">
          <div class="element-box-tp">
            <div class="table-responsive">
              <table class="table table-padded">
                <thead>
                  <tr>
                    <th>
                      Dia Semana
                    </th>
                    <th>
                      1º Horário
                    </th>
                    <th class="text-center">
                      2º Horário
                    </th>
                    <th class="text-center">
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="agenda in listAgenda" :key="agenda._id">
                    <td>
                      <span>{{agenda.dia_semana.name}}</span>
                    </td>
                    <td>
                      <span>{{agenda.hora_inicio_1}} - {{agenda.hora_fim_1}}</span>
                    </td>
                    <td>
                      <span>{{agenda.hora_inicio_2}} - {{agenda.hora_fim_2}}</span>
                    </td>
                    <td class="row-actions">
                      <a title="Excluir" @click="remove(agenda._id)" class="danger" href="#"><i class="os-icon os-icon-ui-15"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created () {
    this.listAgenda = []
    this.agenda.corpo_clinico = this.profissional._id
    this.loadAgenda()
  },
  computed: {
    profissional () {
      return this.$store.getters.corpoClinico
    }
  },
  data () {
    return {
      agenda: {
        corpo_clinico: null,
        dia_semana: null,
        hora_inicio_1: null,
        hora_inicio_2: null
      },
      listDiaSemana: [
        {key: 1, name: 'Domingo'},
        {key: 2, name: 'Segunda-feira'},
        {key: 3, name: 'Terça-feira'},
        {key: 4, name: 'Quarta-feira'},
        {key: 5, name: 'Quinta-feira'},
        {key: 6, name: 'Sexta-feira'},
        {key: 7, name: 'Sábado'}
      ],
      listAgenda: null
    }
  },
  methods: {
    salvar () {
      let idCorpoClinico = this.profissional._id
      if (this.profissional.tempoAtendimento) {
        this.profissional.tempoAtendimento = Number(this.profissional.tempoAtendimento)
      }
      this.$store.dispatch('saveCorpoClinico', this.profissional)
        .then((corpoClinico) => {
          this.$store.dispatch('loadCorpoClinico', idCorpoClinico)
            .then(() => {
              this.$store.dispatch('saveAgenda', this.agenda)
                .then(() => {
                  this.clear()
                  this.loadAgenda()
                })
            })
        })
    },
    clear () {
      this.agenda = {
        corpo_clinico: this.profissional._id,
        dia_semana: '',
        hora_inicio_1: null,
        hora_inicio_2: null
      }
    },
    loadAgenda () {
      this.$store.dispatch('listAgendaPorProfissional', this.profissional._id)
        .then((listAgenda) => {
          this.listAgenda = listAgenda
          this.removeDiaSemana()
        })
    },
    remove (idAgenda) {
      this.$store.dispatch('removeAgenda', idAgenda)
        .then(() => {
          this.listDiaSemana = this.recuperaTodosDiasSemana()
          this.loadAgenda()
        })
    },
    recuperaTodosDiasSemana () {
      return [
        {key: 1, name: 'Domingo'},
        {key: 2, name: 'Segunda-feira'},
        {key: 3, name: 'Terça-feira'},
        {key: 4, name: 'Quarta-feira'},
        {key: 5, name: 'Quinta-feira'},
        {key: 6, name: 'Sexta-feira'},
        {key: 7, name: 'Sábado'}
      ]
    },
    removeDiaSemana () {
      this.listAgenda.forEach(agenda => {
        let index = this.listDiaSemana.findIndex((diaSemana) => diaSemana.key === agenda.dia_semana.key)
        if (index >= 0) {
          this.listDiaSemana.splice(index, 1)
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/cadastroProfissional/AgendaProfissionalForm.vue